import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { forceRender } from '../../../../../../../../../../components/VirtualizedList/actions'

const mapDispatchToProps = (dispatch) => bindActionCreators({ forceRender }, dispatch)

const mapStateToProps = (state) => ({
    searchResults: state.getIn(['ui', 'entityStack', 'search', 'entities']),
    searching: state.getIn(['ui', 'entityStack', 'search', 'searching']),
    searchValue: state.getIn(['ui', 'entityStack', 'search', 'searchValue']),
})

export default (SearchContentComponent) => {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnectSearchContent extends Component {
        static propTypes = {
            forceRender: PropTypes.func.isRequired,
            searching: PropTypes.bool.isRequired,
            searchValue: PropTypes.string.isRequired,
        }

        render() {
            return <SearchContentComponent {...this.props} />
        }
    }

    return HocConnectSearchContent
}
